import React from 'react';
import { addClient } from '../../../../data/serviceClients';

import { API_URLS } from '../../../../helpers/api/API_URLS';
import { basicGET, basicFILEPOST } from '../../../../helpers/api/fetchParams';

import AccordianTitle from '../../../../helpers/uiComponents/Accordian';
import { ActionTabs } from '../../../../helpers/uiComponents/ActionTabs';
import { InputRow } from '../../../../helpers/uiComponents/InputRow';
import { hideMessage, showMessage } from '../../../../helpers/uiFunctions/uiActions';

export class Seo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			metaTitles: [],
		}
		this.handleUpdate = this.handleUpdate.bind(this);
		this.save = this.save.bind(this);
	}
	componentDidMount() {
		this.getData(this.props.currentClient.clientCode);
		this.setState({currentClient: this.props.currentClient});
	}

	upload() {
		showMessage("Uploading SEO Data...")
		var formData = new FormData();
		var file = document.getElementById("meta-titles").files[0];
		formData.append('file', file);

		fetch(API_URLS.API+this.props.currentClient.clientCode+"/seo/titles", basicFILEPOST(localStorage.getItem("token"), formData, "POST"))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong saving the file ...'); }
		})
		.then(data => {
			hideMessage(data.success);
			if (data.success === true) {
				this.getData(this.props.currentClient.clientCode)
			}
		})
		.catch(error => console.log(error));
	}

	getData(clientCode) {
		fetch(API_URLS.API+clientCode+"/seo/titles", basicGET(localStorage.getItem("token")))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong fetching the SEO meta data for this client...'); }
		})
		.then(data => {
			// console.log(data);
			this.setState({metaTitles: data.result});
		})
		.catch(error => console.log(error));

	}
	handleUpdate(e) {
		var key = e.target.name;
		var value = e.target.value;
		var subArr = null;

		if (key.includes(".")) {
			subArr = key.split('.')[0];
			key = key.split('.')[1];
		}

		var type = e.target.type;
		if (type === "checkbox") {
			value = e.target.checked
		}
		var updateClient = this.props.updateClient
        updateClient(key, value, subArr);
	}
	save() {
		showMessage("Saving account...");
		var client = this.props.currentClient;
		delete client.transactions;
		addClient(this.props.currentClient).then(data => {
			hideMessage(data.success);
			// var getClient = this.props.getClient;
			// getClient(this.props.currentClient.clientCode);
		});
	}

	labels() {
		return	(
			<div className="group-labels">
				<label>Page URL</label>
				<label>Meta Title</label>
				<label>Meta Description</label>
			</div>
		);
	}

	render() {
		const { metaTitles } = this.state;

		return (
			<div className="input-group">
				<AccordianTitle title={"SEO / Meta Data"} />
				<div className="accordian-body">
					<ActionTabs
						id={"seo"}
						handleSave={this.save}
					/>
					<div id="seo-inputs" className="inputs">
						<InputRow label="SEO Target Location" onChange={this.handleUpdate} type="text" property="seoLocation" id="seoLocation" value={this.props.currentClient.seoLocation} />
						<InputRow label="Service Areas" onChange={this.handleUpdate} type="text" property="seoServiceAreas" id="seoServiceAreas" value={this.props.currentClient.seoServiceAreas} />
						<InputRow label="Showrooms" onChange={this.handleUpdate} type="text" property="seoShowrooms" id="seoShowrooms" value={this.props.currentClient.seoShowrooms} />
						<div className="input-row">
							<label htmlFor="meta-titles">Meta Title File Upload</label>
							<div>
								<input type="file" name="meta-titles" id="meta-titles" onChange={() => this.upload()} filename={'file name from data here'} />
							</div>
						</div>
						<em>upload a new file to add/replace the current data</em>
					</div>
					<div className="seo-titles">
						<h3>Current Meta Titles</h3>
						<div className="table">
							<div className="table-heading">
								{this.labels()}
							</div>
							<div className="table-body">
								{(metaTitles) && (
									metaTitles.map(meta =>
										<li key={meta.page}>
											<div>{meta.page}</div>
											<div>{meta.seoTitle}</div>
											<div>{meta.seoDescription}</div>
										</li>
									)
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/Seo.js